import { Link } from 'react-router-dom';
import { HomeComponent } from '../../assets/styles/components/Home';

const publicServices = [
  {
    to: '/perfil/crecer',
    title: 'Tu perfil en Comunidad',
    description: 'Consulta tu perfil, pasos de Crecer, próximas clases, tu grupo y más.',
  },
  {
    to: '/servicio/reservacion',
    title: 'Campus Medellín',
    description: 'Regístrate en uno de nuestros eventos o servicios.',
  },
  {
    to: '/crecerplus',
    title: 'Crecer Plus',
    description: 'Accede a los cursos y contenidos formativos para lideres de grupos.',
  },
  {
    to: '/diezmosyofrendas',
    title: 'Diezmos y ofrendas',
    description: 'Realiza tu donación de forma segura.',
  },
  {
    to: '/grupos/registrarse',
    title: 'Registrarse en un grupo',
    description: 'Únete a un grupo de discipulado en Comunidad.',
  },
  {
    to: '/bienvenido',
    title: 'Formulario para nuevos miembros',
    description: 'Si eres nuevo, comienza aquí tu proceso de conexión.',
  },
  {
    to: '/catalogo-red-empresas',
    title: 'Catálogo Red Empresas',
    description: 'Explora el directorio de empresas de la red Comunidad.',
  },
];

const PublicPage = () => {
  return (
    <HomeComponent>
      <div className="PublicHome">
        <header className="PublicHome__header">
          <p className="PublicHome__brand">Comunidad MDE</p>
          <h1 className="title">Bienvenido</h1>
          <p className="PublicHome__intro">Elige el servicio al que quieres acceder.</p>
        </header>

        <nav className="PublicHome__services" aria-label="Servicios públicos">
          {publicServices.map((service) => (
            <Link key={service.to} to={service.to} className="PublicHome__service">
              <span className="PublicHome__service-copy">
                <span className="PublicHome__service-title">{service.title}</span>
                <span className="PublicHome__service-description">{service.description}</span>
              </span>
              <span className="PublicHome__service-arrow" aria-hidden="true">
                →
              </span>
            </Link>
          ))}
        </nav>

        <section className="PublicHome__habeas" aria-labelledby="habeas-data-heading">
          <h2 id="habeas-data-heading">Habeas data</h2>
          <p>
            La Iglesia se compromete a realizar la debida protección de los datos personales
            suministrados con base en la Ley 1581 de 2012 y sus decretos reglamentarios, respetando
            los derechos que los titulares poseen y ofreciendo las herramientas necesarias para que
            estos se garanticen. Igualmente se autoriza el uso y tratamiento de fotos y videos con
            fines comunicativos, en nuestras diferentes plataformas digitales y comunicación interna
            de la iglesia.
          </p>
          <p>
            Si desea más información,{' '}
            <a
              href="https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=49981"
              target="_blank"
              rel="noreferrer"
            >
              puede consultar los términos y condiciones
            </a>
            .
          </p>
        </section>
      </div>
    </HomeComponent>
  );
};

export default PublicPage;
